import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=6a8a9495&scoped=true"
import script from "./Security.vue?vue&type=script&lang=ts"
export * from "./Security.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8a9495",
  null
  
)

export default component.exports